// extracted by mini-css-extract-plugin
module.exports = {"small":"_702fa705","large":"_2bad2bf8"};